/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import * as X from "@/ui";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";


import EuropeImage from "@/assets/about-us-commitment-europe.svg";
import ConfidentialityImage from "@/assets/about-us-commitment-confidentiality.svg";
import RefundImage from "@/assets/about-us-commitment-refund.svg";
import ReliabilityImage from "@/assets/about-us-commitment-reliability.svg";

import "swiper/css";
import "swiper/css/pagination";
import { CommitmentCard } from "@/providers/strapi/content/types/components/about-us.component";
import { useAboutUsPage } from "@/providers/strapi/content/types/singleTypes/about-us-page";
import ReactMarkdown from "react-markdown";


// const defaultData = {
//   commitments: [
//     {
//       image: EuropeImage,
//       title: {
//         en: `A registered tax-free operator in Europe`,
//         fr: `Un opérateur de détaxe agréé en Europe`,
//       },
//       text: {
//         en: `Our VAT refund service fully complies with both EU and national regulations. Zapptax is officially registered as an authorized tax-free operator by the tax and customs authorities in France, Belgium, and Spain.`,
//         fr: `Notre service de détaxe est conforme aux réglementations européennes et nationales. Zapptax est officiellement reconnu comme « opérateur de détaxe » agréé par les autorités fiscales et douanières en France, en Belgique et en Espagne.`,
//       },
//     },
//     {
//       image: ConfidentialityImage,
//       title: {
//         en: `Data security and privacy`,
//         fr: `Sécurité et confidentialité des données`,
//       },
//       text: {
//         en: `We apply the strictest standards in data protection and cybersecurity. Our servers are hosted in Europe and we operate in full compliance with European regulations (GDPR, KYC, AML).`,
//         fr: `Nous appliquons les normes les plus strictes en matière de sécurité et de protection des données. Nos serveurs sont hébergés en Europe et nous opérons en conformité avec les réglementations européennes (RGPD, KYC, AML).`,
//       },
//     },
//     {
//       image: RefundImage,
//       title: {
//         en: `Secure and transparent refunds`,
//         fr: `Des remboursements transparents et sécurisés`,
//       },
//       text: {
//         en: `No hidden fees: we clearly display our foreign exchange rates and let users choose their refund method. We never ask for sensitive information such as credit card CVC codes or any passwords tied to your financial data.`,
//         fr: `Aucun frais caché : nous annonçons clairement les taux de conversion en devise étrangère et offrons à nos utilisateurs le choix de leur méthode de remboursement. Nous ne demandons jamais d’informations sensibles telles que les codes CVC des cartes de crédit ou tout mot de passe lié à vos informations financières.`,
//       },
//     },
//     {
//       image: ReliabilityImage,
//       title: {
//         en: `A reliable and guaranteed service`,
//         fr: `Un service de détaxe fiable et garanti`,
//       },
//       text: {
//         en: `Since 2017, we’ve refunded every validated tax-free form submitted to us — no exceptions. That’s our commitment to a secure, efficient, and no surprises service.`,
//         fr: `Depuis 2017, nous avons remboursé sans exception tous les bordereaux validés qui nous ont été présentés, preuve de notre engagement envers un service sécurisé, efficace et sans surprise.`,
//       },
//     },
//   ]
//   // satisfies Array<{
//   //   image: X.ImageSrc;
//   //   title: X.Localization;
//   //   text: X.Localization;
//   // }>,
// }

const images = [EuropeImage, ConfidentialityImage, RefundImage, ReliabilityImage]
type DataType = {
  commitments: Array<
    {
      image: X.ImageSrc,
      title: string,
      text: string
    }>
}

const buildData = (content: CommitmentCard): DataType => ({
  commitments: content.commitmentItems.map((item, index) => ({
    image: images[index] as X.ImageSrc,
    title: item.title,
    text: item.content
  })
  )
})


export function CommitmentsSection(_props: X.PageProps) {
  // const tr = X.useTranslator();
  const content = useAboutUsPage('commitmentsCard')
  const data = buildData(content)
  return (
    <section id="commitments" className={X.clsx(
      "scroll-mt-[120px] relative xl:bg-surface-purple-darker",
      "pt-6 pb-4 xl:pt-0 xl:pb-0 relative",
      "xl:max-w-content xl:mx-auto xl:my-20 xl:pb-15 xl:mt-30 xl:rounded-4xl xl:p-8 xl:pt-10",
    )}>
      <ReactMarkdown components={{
        p: ({ ...props }) => <h2 {...props} className="relative z-10 mx-mobile-margin xl:mx-0 text-[36px] xl:text-[48px] xl:text-center [&_strong]:font-medium" />
      }}>
        {content.title}
      </ReactMarkdown>
      {/* <h2 className="relative z-10 mx-mobile-margin xl:mx-0 text-[36px] xl:text-[48px] xl:text-center [&_strong]:font-medium">
        {tr({
          en: <>Our <strong>Commitments</strong></>,
          fr: <>Nos <strong>engagements</strong></>,
        })}
      </h2> */}

      <Desktop data={data} />
      <Mobile data={data} />
    </section>
  );
}


function Desktop({ data }: { data: DataType }) {
  // const tr = X.useTranslator();

  return (
    <div className={X.clsx(X.desktopOnly("flex"), "flex-col gap-4 mt-10")}>
      {X.groupBy(2, data.commitments).map((row, i) => (
        <div key={i} className="flex flex-row gap-6">
          {row.map((x, j) => (
            <div key={j} className="flex-1 bg-white rounded-xl p-10 pt-8 flex flex-col gap-4">
              <X.Image src={x.image}
                // alt={tr(x.title)}
                alt={x.title}
              />
              <ReactMarkdown components={{
                p: ({ ...props }) => <h3 {...props} className="text-[26px] [&_strong]:font-semibold leading-tight" />,
                h1: ({ ...props }) => <h3 {...props} className="text-[26px] [&_strong]:font-semibold leading-tight" />,
                h2: ({ ...props }) => <h3 {...props} className="text-[26px] [&_strong]:font-semibold leading-tight" />,
                h3: ({ ...props }) => <h3 {...props} className="text-[26px] [&_strong]:font-semibold leading-tight" />,
                h4: ({ ...props }) => <h3 {...props} className="text-[26px] [&_strong]:font-semibold leading-tight" />
              }}>
                {x.title}
              </ReactMarkdown>
              {/* <h3 className="text-[26px] font-semibold leading-tight">

                {x.title}
              </h3> */}
              <ReactMarkdown components={{
                p: ({ ...props }) => <p {...props} className="text-[20px] leading-tight" />,
              }}>
                {x.text}
              </ReactMarkdown>

              {/* <p className="text-[20px] leading-tight">

                {x.text}
              </p> */}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}


function Mobile({ data }: { data: DataType }) {
  const id = X.useId();
  // const tr = X.useTranslator();

  return (
    <div className={X.mobileOnly()}>
      <Swiper
        modules={[Pagination]}
        spaceBetween={16}
        slidesPerView={1.3}
        className="mt-6 relative z-10 flex flex-row"
        slidesOffsetBefore={32}
        slidesOffsetAfter={32}
        pagination={{
          el: `#${id}`,
          bulletActiveClass: "w-8 !bg-gray",
          bulletClass: "block w-2 h-2 bg-white rounded-full transition-all duration-300",
          clickable: false,
        }}
      >
        {data.commitments.map((x, i) => (
          <SwiperSlide key={i}>
            <div className="bg-white h-full rounded-lg py-6 px-4 flex flex-col gap-4 mb-2">
              <X.Image src={x.image}
                // alt={tr(x.title)}
                alt={x.title}
              />
              {/* <h3 className="text-[20px] font-semibold leading-tight">

                {x.title}
              </h3> */}
              <ReactMarkdown components={{
                h1: ({ ...props }) => <h3 {...props} className="text-[20px] [&_strong]:font-semibold leading-tight" />,
                h2: ({ ...props }) => <h3 {...props} className="text-[20px] [&_strong]:font-semibold leading-tight" />,
                h3: ({ ...props }) => <h3 {...props} className="text-[20px] [&_strong]:font-semibold leading-tight" />,
                h4: ({ ...props }) => <h3 {...props} className="text-[20px] [&_strong]:font-semibold leading-tight" />
              }}>
                {x.title}
              </ReactMarkdown>
              <ReactMarkdown components={{
                p: ({ ...props }) => <p {...props} className="text-[16px]" />,
              }}>
                {x.text}
              </ReactMarkdown>
              {/* <p className="text-[16px]">

                {x.text}
              </p> */}
            </div>
          </SwiperSlide>
        ))}

        <div id={id} className="mx-mobile-margin flex flex-row gap-2 mt-4 mb-8" />
      </Swiper>

      <div className="absolute inset-0 right-mobile-margin-half rounded-r-4xl z-0 bg-surface-purple-darker" />
    </div>
  );
}
